import styled from 'styled-components';
import {IconButton} from '@material-ui/core';

export const IconButtonPrinter = styled(IconButton)`
  padding: 6px !important;
`;

export const OrdersTableWrapper = styled.div`
  .MuiTable-root {
    tr {
      &:first-child {
        th {
          &:nth-child(1) {
            width: 16%;
            @media (max-width: 1000px) {
              width: 15%;
            }
          }

          &:nth-child(2) {
            width: 10%;
          }

          &:nth-child(3) {
            width: 20%;
          }

          &:nth-child(4) {
            width: 18%;
            @media (max-width: 1000px) {
              width: 18%;
            }
          }

          //&:nth-child(4) {
          //  width: 14%;
          //  @media (max-width: 1000px) {
          //    width: 13%;
          //  }
          //}

          &:nth-child(5) {
            width: fit-content;
          }

          &:nth-child(6) {
            width: 13%;
          }

          &:nth-child(7) {
            width: 3%;
          }
        }
      }
    }
  }
  &.withPickupReady {
    .MuiTable-root {
      tr {
        &:first-child {
          th {
            &:nth-child(1) {
              width: 18%;
              @media (max-width: 1000px) {
                width: 16%;
              }
            }

            &:nth-child(2) {
              width: 9%;
            }

            &:nth-child(3) {
              width: 12%;
            }

            &:nth-child(4) {
              text-align: center;
              width: 11%;
            }

            &:nth-child(5) {
              width: 12%;
            }

            &:nth-child(6) {
              width: 13%;
            }

            &:nth-child(7) {
              width: 3%;
            }
          }
        }
      }
    }
  }
  &.withOtterBrandName {
    overflow-x: auto;
    & > div {
      min-width: 1100px;
      &.NoOrders {
        min-width: 100%;
      }
    }
    table {
      min-width: 1040px;
      &.NoOrders {
        min-width: 100%;
      }
    }
    .MuiTable-root {
      tr {
        &:first-child {
          th {
            &:nth-child(1) {
              width: 14%;
            }

            &:nth-child(2) {
              width: 15%;
              min-width: 150px;
              padding-right: 16px;
            }

            &:nth-child(3) {
              width: 10%;
              padding-left: 12px;
            }

            &:nth-child(4) {
              width: 16%;
            }

            &:nth-child(5) {
              width: fit-content;
            }

            &:nth-child(6) {
              width: 12%;
            }

            &:nth-child(7) {
              width: 13%;
              min-width: 110px;
            }

            &:nth-child(8) {
              width: 12%;
            }
          }
        }
        td {
          &:nth-child(2) {
            min-width: 150px;
            white-space: nowrap;
            padding-right: 16px;
          }
          &:nth-child(3) {
            padding-left: 12px;
          }
          &:nth-child(7) {
            min-width: 110px;
            white-space: nowrap;
          }
        }
      }
    }
  }
`;
